module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/mail_case_02-c74d05661138429904900f9c420f26e5.png";